/* eslint-disable indent */
import React, { useEffect } from "react";
import {
  SFTypography,
  SFIcons,
  SFStack,
  SFContent,
  SFHelpers,
  SFUseStyled,
} from "@sf-core";
import { useNavigate } from "react-router-dom";
import SkillPathPlayButton from "./skillPathPlayButton";
import { useTranslation } from "react-i18next";
import { getAcademyUrl, getJobUrl, getSkillUrl } from "../../constants/urls";
import { DOMAIN_TYPE_IDS } from "../../constants/domainTypes";
import { useSelector, useDispatch } from "react-redux";
import { skillPathPageActions } from "../../redux/reducers/skillPathPageReducer";

const { styled } = SFUseStyled();

const SFStyledTypography = styled(SFTypography)(({ theme }) => ({
  color: theme.palette.grey[200],
}));

const SFStyledStack = styled(SFStack)(({ theme }) => ({
  cursor: "pointer",
}));

const StyledStack = styled(SFStack)(({ theme }) => ({
  minWidth: "60px",
}));

const SkillPathDetails = ({ item, courses, preview = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { name, totalDuration, totalCourses, level, description } = item;

  const skillPathInfo = useSelector((state) => state.skillPathPage);

  useEffect(() => {
    if (skillPathInfo.skillPathId !== item.id) {
      dispatch(
        skillPathPageActions.setState({
          skillPathId: item.id,
          domainId: null,
          domainName: null,
          domainTypeId: null,
          domainStatus: null,
        })
      );
    }
  }, [item]);

  return (
    <SFStack spacing={3}>
      <SFStack spacing={2}>
        <SFStack alignItems="flex-start">
          {skillPathInfo.domainName && (
            <SFStyledStack
              direction="row"
              alignItems="center"
              onClick={() => {
                if (skillPathInfo.domainTypeId === DOMAIN_TYPE_IDS.ACADEMY) {
                  navigate(getAcademyUrl(skillPathInfo.domainId));
                } else if (skillPathInfo.domainTypeId === DOMAIN_TYPE_IDS.JOB) {
                  navigate(getJobUrl(skillPathInfo.domainId));
                } else if (
                  skillPathInfo.domainTypeId === DOMAIN_TYPE_IDS.SKILL
                ) {
                  navigate(getSkillUrl(skillPathInfo.domainId));
                }
              }}
            >
              <SFStyledTypography variant="body1">
                {skillPathInfo.domainName}
              </SFStyledTypography>
              <SFIcons.SFArrowRightIcon size={"small"} color="grey200" />
            </SFStyledStack>
          )}
          <SFTypography variant="detailsPageHeading">{name}</SFTypography>
        </SFStack>
      </SFStack>
      <SFStack spacing={3} direction="row">
        <StyledStack direction="row" spacing={1} alignItems="center">
          <SFIcons.SFTimerIcon size={"small"} color="grey200" />
          <SFStyledTypography variant="body2">
            {totalDuration
              ? t("lxpComponents.skillPathDetails.hours", {
                  count: SFHelpers.DurationFormatter(
                    totalDuration,
                    SFHelpers.DurationFormatterOptions.HOURS_ONLY
                  ),
                })
              : t("lxpComponents.skillPathDetails.emptyValue")}
          </SFStyledTypography>
        </StyledStack>
        <StyledStack direction="row" spacing={1} alignItems="center">
          <SFIcons.SFImportContactsIcon size={"small"} color="grey200" />
          <SFStyledTypography variant="body2">
            {totalCourses
              ? t("lxpComponents.skillPathDetails.courses", {
                  count: totalCourses,
                })
              : t("lxpComponents.skillPathDetails.emptyValue")}
          </SFStyledTypography>
        </StyledStack>
        <StyledStack direction="row" spacing={1} alignItems="center">
          <SFIcons.SFSignalCellularAltRoundedIcon
            size={"small"}
            color="grey200"
          />
          <SFStyledTypography variant="body2">
            {level
              ? t("lxpComponents.skillPathDetails.level", {
                  value: level,
                })
              : t("lxpComponents.skillPathDetails.emptyValue")}
          </SFStyledTypography>
        </StyledStack>
        <StyledStack direction="row" spacing={1} alignItems="center">
          <SFIcons.SFLanguageIcon size={"small"} color="grey200" />
          <SFStyledTypography variant="body2">
            {skillPathInfo.domainName
              ? skillPathInfo.domainName
              : t("lxpComponents.skillPathDetails.emptyValue")}
          </SFStyledTypography>
        </StyledStack>
      </SFStack>
      <SFContent scrollable maxLines={4}>
        {description}
      </SFContent>
      <SkillPathPlayButton
        item={item}
        skillPathInfo={skillPathInfo}
        courses={courses}
        preview={preview}
      />
    </SFStack>
  );
};

export default SkillPathDetails;
